import { Pipe, PipeTransform } from '@angular/core';
import { deburr } from 'lodash';
import { Course } from '../models';

@Pipe({
  name: 'filterCourse',
  standalone: false,
})
export class FilterCoursePipe implements PipeTransform {
  public transform(courses: Course[], title: string): any {
    if (title) {
      const coursesFiltered = courses.filter((course) => this.compareLike(course.titulo, title));
      return coursesFiltered || [];
    }
    return courses;
  }

  private compareLike(courseTitle: string, filterTitle: string): boolean {
    return this.sanitize(courseTitle).toLowerCase().includes(this.sanitize(filterTitle).toLowerCase());
  }

  private sanitize(value: string): string {
    return deburr(value.trim());
  }
}
